<template>
    <div class="me">
        <div class="placeholder"></div>
        <div class="me-bg"></div>
        <div class="me-header">
            <div class="me-header-l">
                <div class="img">
                    <img src="../../assets/img/me/icon1.png" alt=""></img>
                </div>
                <span>{{this.$store.state.globalAddress.slice(0,6) +"****" +this.$store.state.globalAddress.slice(38,42)}}</span>
            </div>
            <div class="me-header-r">
                <img src="../../assets/img/me/icon2.png" alt="" @click="copyAddr()"></img>
                <!-- <img src="../../assets/img/me/icon3.png" alt=""></img> -->
            </div>

        </div>
        <div class="me-card">
            <div>
                <div class="title">{{ $t('me.assets') }}(USD)</div>
                <div class="value">$ {{Number(auxU)+Number(usdtBalance)}}</div>
                <div class="btn-box">
                    <!-- <div @click="go('/recharge')">{{ $t('me.recharge') }}</div>
                    <div @click="go('/transfer')">{{ $t('me.transfer') }}</div>
                    <div @click="go('/record')">{{ $t('me.record') }}</div> -->
                </div>
            </div>
        </div>
        <div class="me-list">
            <div class="me-list-item" >
                <div class="me-list-item-l">
                    <img src="../../assets/img/me/icon4.png" alt="">
                  
                    <span >YUX</span>
                 
                </div>
                <div class="me-list-item-r">
                    <div class="label">{{Number(auxBalance).toFixed(4)}}</div>
                    <div class="value">≈${{ Number(auxU).toFixed(4)}}</div>
                </div>
            </div>
            <div class="me-list-item">
                <div class="me-list-item-l">
                    <img  src="../../assets/img/me/icon10.png" alt="">
                    <span >USDT</span>
                </div>
                <div class="me-list-item-r">
                    <div class="label">{{Number(usdtBalance).toFixed(4)}}</div>
                    <div class="value">≈${{Number(usdtBalance).toFixed(4)}}</div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import {
    Field,
    Swipe,
    SwipeItem,
    Circle,
    Tab,
    Tabs,
    Popup,
    Progress,
    Button,
} from "vant";
import { copyToClipboard } from "@/utils";
import NumberScroll from "@/components/NumberScroll.vue";
import SplitText from "@/components/SplitText/SplitText.vue";
import ShinyText from "@/components/ShinyText/ShinyText.vue";
import AnimatedContent from "@/components/AnimatedContent/AnimatedContent.vue";
import FadeContent from "@/components/FadeContent/FadeContent.vue";


import Web3 from 'web3'
import contractaa from '../contract/index.js'
let web3
web3 = new Web3(window.ethereum)

export default {
    name: "me",
    components: {
        SplitText,
        ShinyText,
        AnimatedContent,
        FadeContent,
        Field,
        Swipe,
        SwipeItem,
        Tab,
        VanCircle: Circle,
        Tabs,
        Popup,
        Progress,
        Button,
        NumberScroll,
    },
    data() {
        return {
            value: "",
            dd: 0.0,
            usdtBalance:0,
            auxBalance:0,
            auxU:0,
        };
    },
    computed: {},
    mounted() {
        let timer = setInterval(async () => {
            if (true) {
                this.getInfo()
                clearInterval(timer)
            }
        }, 500);
    },
    methods: {
        go(path) {
            this.$router.push(path)
        },
        async getInfo(){
            let that = this;
            let address = this.$store.state.globalAddress;
            let AuxContract = new web3.eth.Contract(contractaa.abiUsdt,contractaa.yuxToken);
            let UsdtContract = new web3.eth.Contract(contractaa.abiUsdt,contractaa.usdtToken);
            let ExchangeContract = new web3.eth.Contract(contractaa.abiExchange,contractaa.exchangeToken);
            await AuxContract.methods.balanceOf(address).call({from:address}).then(function(result){
                that.auxBalance = web3.utils.fromWei(result,'ether')
            })
            await UsdtContract.methods.balanceOf(address).call({from:address}).then(function(result){
                that.usdtBalance = web3.utils.fromWei(result,'ether')
            })
            await ExchangeContract.methods.price(address).call({from:address}).then(function(result){
                let price  = web3.utils.fromWei(result,'ether')
           
                that.auxU = Number(that.auxBalance) * Number(price)
      
     
            })
        },
        copyAddr(){
            let code = this.$store.state.globalAddress
            copyToClipboard(code)
            this.$toast.success('复制成功');
        },
    },
};
</script>

<style lang="less" scoped>
.me {
    position: relative;
    //overflow-x: hidden;
    flex: 1;

    //height: 100%;
    background-size: 100% 800px;
    padding: 0 20px 42px;
    background: url("../../assets/img/home/header-bg.png") no-repeat;
    background-size: 471.9px 240.62px;
    background-position: -60px -97px;

    &-bg {
        width: 375px;
        position: absolute;
        height: 178px;
        top: -44px;
        background: url('../../assets/img/me/header-bg.png') no-repeat center;
        background-size: 100% 100%;
    }

    .placeholder {
        height: 34px;
    }

    .px15 {
        padding: 0 15px;
    }


    &-header {
        margin-top: 32px;
        display: flex;
        justify-content: space-between;
        position: relative;
        z-index: 11;

        &-l {
            display: flex;
            align-items: center;

            .img {
                height: 64px;
                width: 64px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;

                img {
                    width: 60px;
                    height: 60px;
                }
            }

            span {
                font-weight: bold;
                font-size: 16px;
                margin-left: 14px;
            }
        }

        &-r {
            display: flex;
            align-items: center;

            img {
                width: 20px;
                height: 20px;
            }

            img+img {
                margin-left: 24px;
            }
        }
    }

    &-card {
        margin-top: 24px;
        box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
        background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
        border-radius: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        >div {
            background: linear-gradient(236deg, #1E1D24 9%, #13121B 80%);
            backdrop-filter: blur(30px);
            border-radius: 16px;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            border-radius: 16px;
            height: 150px;
            padding: 24px 16px;


            .title {
                font-size: 16px;
                line-height: 12px;
            }

            .value {
                margin-top: 16px;
                line-height: 20px;
                font-weight: bold;
                font-size: 20px;
            }

            .btn-box {
                display: flex;
                justify-content: space-between;
                margin-top: 20px;

                >div {
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 8px;
                    height: 36px;
                    line-height: 14px;
                    font-size: 14px;
                    width: 90px;
                    font-weight: 500;
                    color: #000000;
                   background: linear-gradient(109deg, #0DF1D5 0%, #0190D1 97%);

                }
            }
        }
    }

    &-list {
        &-item {
            margin-top: 24px;
            height: 40px;
            display: flex;
            justify-content: space-between;

            &-l {
                display: flex;
                align-items: center;

                >img {
                    width: 40px;
                    height: 40px;
                }

                span {
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 16px;
                    margin-left: 12px;
                }
            }

            &-r {
                .label {
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 16px;
                    text-align: right;
                }

                .value {
                    margin-top: 8px;
                    line-height: 16px;
                    font-size: 12px;
                    opacity: 0.6;
                    text-align: right;
                }
            }
        }
    }

}
</style>
<style lang="less"></style>